import React from 'react'
import Navbar from '../components/Navbar'
import IletisimComp from '../components/Iletisim_comp'
import Footer from '../components/Footer'

function Iletisim() {
  return (
    <div>
        <Navbar />
        <IletisimComp />
        <Footer />
    </div>
  )
}

export default Iletisim
